import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Geek at a music festival: Day 5",
  "description": "",
  "published": "2012-07-16T00:00:00.000Z",
  "redirect_from": ["/blog/geek-at-a-music-festival-day-5/swizec/4861"],
  "categories": "Axl Rose, Concert, exit, festival, Guitarist, guns-n-roses, Slash, Travel + Events, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-12-e1342473433868-1024x764.jpg",
        "alt": "Fat Axl",
        "title": "Fat Axl"
      }}></img></p>
    <p>{`Don't rely on your brain the day after a festival.`}</p>
    <p>{`Don't have any prior engagements either.`}</p>
    <p>{`It won't go well. I promise. Something as simple as picking up your car can go terribly wrong when you walk for 30 minutes across the town, get the Awesome Dude Who Loaned You His Garage to open it and your first thought is `}<em parentName="p">{`"Oh right, I need my car keys for this"`}</em></p>
    <p>{`By that point it's already so late it makes more sense to go for lunch then re-do the trip. And before you know it, it's 5PM and you're several hours late already.`}</p>
    <p>{`Then you almost doze off a few times on the highway, get lost in another strange city and voila, the day is gone.`}</p>
    <p>{`But hey, at least you had an epic time at the festival the previous night so all is well!`}</p>
    <p>{`Maybe `}<em parentName="p">{`you`}</em>{` did, but I was at the `}<a parentName="p" {...{
        "href": "http://gunsnroses.com",
        "title": "Guns N' Roses"
      }}>{`Guns And Roses`}</a>{` concert the whole night. It was probably a good concert, we just got there 20 years too late ... it was just a mess. Too many old songs, too many ballads, too many old people.`}</p>
    <p>{`We know you made a new album or two since Your Time, but we don't really care. Play the ten songs we came for and let us home. No point in dragging the whole thing out for three hours. Especially when you start off with an hour of ballads.`}</p>
    <p>{`I didn't even know they made so many!`}</p>
    <p>{`And the breaks! My god, why were there so many breaks? Is Fat Axl really `}<em parentName="p">{`that`}</em>{` out of shape that we even had to hear a song made by the bassist, a song by a guitarist, a ten minute guitar solo (and not by Faux Slash) and a fifteen minute piano solo? The last two hours there was a five minute break between each song ...`}</p>
    <p>{`And Faux Slash was really offensive. Even to me who's never heard the real thing live. The guy is obviously a decent guitarist, so why does he impersonate Slash in every little thing?`}</p>
    <p>{`Every. Little. Thing.`}</p>
    <p>{`Everything from the hat to the positioning and poses on stage. Maybe they just hired an actor and he doesn't even play the songs? Wouldn't be surprised if even the tattoos are copied over mark for mark ...`}</p>
    <p>{`But, y'know, the bastards have figured out their setlist so well that those of us who managed to stay until the end actually `}<em parentName="p">{`liked-ish`}</em>{` the concert because the last song was bloody good. If a little off tune and Axl was already croaking a bit.`}</p>
    <p>{`Oh yeah, Axl, famous for his voice, actually croaked a few times when trying to talk. That was both fun and sad at the same time.`}</p>
    <p>{`PS: his famous dance step looks ... odd ... now that he's fat.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-42-e1342473520987-1024x764.jpg",
        "alt": "@vranac's face sums up the concert",
        "title": "@vranac's face sums up the concert"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-61-e1342473595626-1024x764.jpg",
        "alt": "Fat Axl played November Rain himself",
        "title": "Fat Axl played November Rain himself"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-22-e1342473749555-1024x764.jpg",
        "alt": "Faux Slash",
        "title": "Faux Slash"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo4-e1342473839169.jpeg",
        "alt": "Khal Drogo guitarist",
        "title": "Khal Drogo guitarist"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-33-e1342474026158.jpeg",
        "alt": "This guitarist was actually pretty decent, whomever he is",
        "title": "This guitarist was actually pretty decent, whomever he is"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-51-e1342474564398.jpeg",
        "alt": "Crowd had fun though",
        "title": "Crowd had fun though"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-7-1024x764.jpg",
        "alt": "But we were all glad when it was over",
        "title": "But we were all glad when it was over"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100106846_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825"
        }}>{`Geek at a music festival: Day 1`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-2/swizec/4830"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100305583_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-2/swizec/4830"
        }}>{`Geek at a music festival: Day 2`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-3/swizec/4838"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100568602_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-3/swizec/4838"
        }}>{`Geek at a music festival: Day 3`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-4/swizec/4850"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/100693979_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-4/swizec/4850"
        }}>{`Geek at a music festival: Day 4`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=51b99ab0-7c7c-4e0c-a525-9c271cc5e298",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      